import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'relationshipTypePlural',
})
export class RelationshipTypePlural implements PipeTransform {
  transform(
    relationshipType: 'Spouse' | 'Children' | 'Parents' | 'Siblings' | 'Grandparents' | 'Grandchildren' | 'Other dependents' | 'Friends' | string
  ): string {
    let res: string;
    // if (this.filteredList.length > 1) {
    switch (relationshipType) {
      case 'Spouse':
        res = 'Spouse';
        break;
      case 'Children':
        res = 'Children';
        break;
      case 'Parents':
        res = 'Parents';
        break;
      case 'Siblings':
        res = 'Siblings';
        break;
      case 'Grandparents':
        res = 'Grandparents';
        break;
      case 'Grandchildren':
        res = 'Grandchildren';
        break;
      case 'Other dependents':
        res = 'Other dependents';
        break;
      case 'Friends':
        res = 'Friends';
        break;
      case 'Extended Family':
        res = 'Extended Family Members';
        break;

      case 'Family Users':
        res = ' Immediate Family Users';
        break;
      default:
        res = relationshipType;
    }

    return res;
  }
}
